import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DxCheckBoxComponent, DxCheckBoxModule, DxPopupComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { SessionContextService } from 'src/app/services/session-context.service';
import { Resource } from '../../model/resource.model';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {

  resource: Resource = null;
  @Output() CloseDlg: EventEmitter<{ Signed: boolean, Resource: Resource, AcceptanceType: number }> = new EventEmitter<{ Signed: boolean, Resource: Resource, AcceptanceType: number }>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(DxCheckBoxComponent) chkSignedDisclaimerValue: DxCheckBoxComponent;
  @ViewChild(DxSelectBoxComponent) sbxAcceptanceType: DxSelectBoxComponent;

  Paragraph1Text: string = "The client is required to sign a disclaimer(s) because the selected session and resource combination exceed the safety policy or skin type matrix limits.";
  DisclaimerCode: string = "";
  DisclaimerTextList: string[] = [];
  dsAcceptanceTypes: any = null;

  constructor(private session: SessionContextService) {
    this.show = this.show.bind(this);
    this.onShowing = this.onShowing.bind(this);
    this.onHiding = this.onHiding.bind(this);

    this.btnContinue = this.btnContinue.bind(this);
    this.btnCancel = this.btnCancel.bind(this);

    this.dsAcceptanceTypes = [
      { Id: 0, Name: "Written Acceptance" },
      { Id: 1, Name: "Verbal Acceptance" },
    ];
  }

  ngOnInit(): void {
  }

  onShowing(e) {
    if (this.chkSignedDisclaimerValue != undefined) {
      this.chkSignedDisclaimerValue.value = false;
    }
    this.update();
  }

  onHiding(e) {
  }

  public show(e: Resource) {
    this.resource = e;
    this.popup.visible = true;
    this.update();
  }

  update() {
    if (this.resource == null)
      return;

    this.Paragraph1Text = "";
    this.DisclaimerTextList = [];
    this.DisclaimerCode = this.resource.DisclaimerCode;

    var safetyPolicyDisclaimer = this.session.defaultData.defData.Disclaimers.find(i => i.DisclaimerType == 4);
    var skinTypeDisclaimer = this.session.defaultData.defData.Disclaimers.find(i => i.DisclaimerType == 2);

    if (this.resource.SafetyPolicyDisclaimerRequired == true && this.resource.SkinTypeDisclaimerRequired == false) {
      this.Paragraph1Text = "This client has exceeded the maximum number of sessions permitted within the safety policy. It is recommended that the client adheres to the safety policy and increases the time between tanning sessions. The client must acknowledge this, and if they choose to continue with their selected session against this recommendation, they must sign a safety policy override disclaimer and accept any liability for personal injury resulting from exceeding the safety policy in place. ";
      this.DisclaimerTextList.push(safetyPolicyDisclaimer.Text);
    }
    if (this.resource.SafetyPolicyDisclaimerRequired == false && this.resource.SkinTypeDisclaimerRequired == true) {
      this.Paragraph1Text = "Based on the client's skin type, the selected session exceeds the recommended maximum duration available for this client. It is recommended that the client select a shorter session in line with the company's skin type policy. Should the client decide to proceed with the selected session, they must sign a skin type override disclaimer and accept any liability for personal injury resulting from exceeding the recommended maximum duration. ";
      this.DisclaimerTextList.push(skinTypeDisclaimer.Text);
    }
    if (this.resource.SafetyPolicyDisclaimerRequired == true && this.resource.SkinTypeDisclaimerRequired == true) {
      this.Paragraph1Text = "This client has exceeded the maximum number of sessions permitted within the safety policy. It is recommended that the client adheres to the safety policy and increases the time between tanning sessions.  The client must acknowledge this, and if they choose to continue with their selected session against this recommendation, they must sign a safety policy override disclaimer and accept any liability for personal injury resulting from exceeding the safety policy in place. ";
      this.Paragraph1Text = this.Paragraph1Text + "Based on the client's skin type, the selected session exceeds the recommended maximum duration available for this client. It is recommended that the client select a shorter session in line with the companies skin type policy. Should the client decide to proceed with the selected session, they must sign a skin type override disclaimer and accept any liability for personal injury resulting from exceeding the recommended maximum duration. ";

      this.DisclaimerTextList.push(safetyPolicyDisclaimer.Text);
      this.DisclaimerTextList.push(skinTypeDisclaimer.Text);
    }
  }

  btnContinue(e) {
    if (this.sbxAcceptanceType.value == undefined || this.chkSignedDisclaimerValue.value == undefined)
      return;
    if (this.sbxAcceptanceType?.value < 0 || this.chkSignedDisclaimerValue?.value == false)
      return;

    this.CloseEditor(this.sbxAcceptanceType.value, this.chkSignedDisclaimerValue?.value || false);
  }

  btnCancel(e) {
    if (this.chkSignedDisclaimerValue != undefined) {
      this.chkSignedDisclaimerValue.value = false;
    }
    this.CloseEditor(-1, false);
  }

  CloseEditor(AcceptanceType: number, DisclaimerSigned: boolean) {
    this.CloseDlg.emit({ Signed: DisclaimerSigned, Resource: this.resource, AcceptanceType: AcceptanceType });
    this.popup.visible = false;
    this.Paragraph1Text = "The client is required to sign a disclaimer because the selected session and resource combination.";
    this.DisclaimerTextList = [];
    this.resource = null;
    this.DisclaimerCode = "";
    this.sbxAcceptanceType.value = null;
    if (this.chkSignedDisclaimerValue != undefined) {
      this.chkSignedDisclaimerValue.value = false;
    }
  }
}
